import {RouterModule, Routes} from "@angular/router";
import {ApiFetchingComponent} from "./api-fetching.component";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InlineSVGModule} from "ng-inline-svg";
import {CRUDTableModule} from "../../../../shared/components/crud-table";
import {NgbDatepickerModule, NgbModalModule} from "@ng-bootstrap/ng-bootstrap";
import {MatDividerModule} from "@angular/material/divider";
import {NgxDropzoneModule} from "ngx-dropzone";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatIconModule} from "@angular/material/icon";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatRadioModule} from "@angular/material/radio";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {SharedModule} from "../../../../shared/shared.module";
import {MatTabsModule} from "@angular/material/tabs";
import {MatStepperModule} from "@angular/material/stepper";
import {NgModule} from "@angular/core";
import {EntityResolver} from "../_resolvers/entity.resolver";
import {SchemaPkResolver} from "./schema-pk.resolver";

const routes: Routes = [
  {
    path: '',
    component: ApiFetchingComponent,
    resolve: {
      rsEntity: EntityResolver,
      rsSchemaPkList: SchemaPkResolver,
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    InlineSVGModule,
    CRUDTableModule,
    NgbModalModule,
    NgbDatepickerModule,
    MatDividerModule,
    NgxDropzoneModule,
    MatCheckboxModule,
    MatIconModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSlideToggleModule,
    FormsModule,
    SharedModule,
    MatTabsModule,
    MatStepperModule
  ],
  exports: [
    RouterModule
  ],
  declarations: [
    ApiFetchingComponent
  ],
  entryComponents: [],
  providers: [
    EntityResolver
  ]
})
export class ApiFetchingModule {}
